/**
 * Site feature flag domain models.
 *
 * The flag vocabulary is a closed `as const` tuple: adding a flag the backend
 * supports is one entry here plus its display info, and every mapped type below
 * then requires it.
 */

export const SITE_FEATURE_FLAGS = ['swingCapture'] as const;

export type SiteFeatureFlag = (typeof SITE_FEATURE_FLAGS)[number];

/** Every known flag, always a boolean. An unset flag is `false`. */
export type SiteFeatures = { readonly [K in SiteFeatureFlag]: boolean };

export interface SiteFeaturesState {
  readonly siteId: string;
  readonly features: SiteFeatures;
  /** ISO timestamp of the last write, or null if no flag has ever been written. */
  readonly updatedAt: string | null;
  /** Keycloak user id of the operator behind the last write, or null. */
  readonly updatedBy: string | null;
}

export interface SiteFeatureInfo {
  readonly label: string;
  readonly description: string;
  /** The feature is still in beta; the UI labels it as such. */
  readonly isBeta: boolean;
}

export const SITE_FEATURE_INFO: { readonly [K in SiteFeatureFlag]: SiteFeatureInfo } = {
  swingCapture: {
    label: 'Swing Capture',
    description: 'Makes the swing capture view available to players at this site.',
    isBeta: true,
  },
};

export const DEFAULT_SITE_FEATURES: SiteFeatures = {
  swingCapture: false,
};
